import Hero from '../../components/Hero'
import './GovernmentPublic.css'

const GovernmentPublic = () => {
  return (
    <>
      <Hero 
        title="Government & Public Infrastructure"
        subtitle="Secure, compliant cleaning for public facilities and spaces."
        backgroundImage="/sectors/government/government.png"
        height="55.78125vh"
      />
      
      <section>
        <div className="section-header">
          <h2>Sector Overview</h2>
        </div>
        <p>Maintaining a high standard of cleanliness in government offices and public spaces not only ensures public safety but also demonstrates respect for the community. Our personnel undergo security clearances and specialised training to meet stringent compliance requirements. We provide reliable, discreet services that keep civic facilities operational and welcoming.</p>
        <div className="gov-grid">
          <article>
            <h3>Government Offices &amp; Administration</h3>
            <p>Daily cleaning for municipal buildings, council chambers and administrative centres, focusing on high‑traffic areas and public reception spaces.</p>
          </article>
          <article>
            <h3>Transport Hubs &amp; Public Facilities</h3>
            <p>Cleaning and sanitisation for airports, train stations, bus terminals and ferry ports to keep travellers safe and comfortable.</p>
          </article>
          <article>
            <h3>Parks, Courts &amp; Community Spaces</h3>
            <p>Litter collection, restroom maintenance and grounds care for parks, playgrounds, sports complexes and courthouses.</p>
          </article>
          <article>
            <h3>Emergency Services Stations</h3>
            <p>Specialised cleaning for police, fire and ambulance stations, supporting readiness and compliance with occupational health standards.</p>
          </article>
        </div>
      </section>
      
      <section className="cta-section">
        <h2>Serve the Community</h2>
        <p>We're committed to keeping public spaces safe and well‑presented. Speak with us about a cleaning program tailored to your infrastructure.</p>
        <a className="cta-button" href="/contact">Enquire Now</a>
      </section>
    </>
  )
}

export default GovernmentPublic
